<template>
  <kendo-window ref="kendoWindowRef"
                :title="'솔루션별 권한추가'"
                :modal="true"
                :width="'982px'"
                style="z-index: 10004; transform: scale(1); opacity: 1; display:none;"
                @close="onCloseKendoWindow">
    <div class="pwindow">
      <div class="k-window-content k-content">
        <div class="k-desc">
          <ul class="k-sea">
            <li class="w30">
              <dropdown-solution ref="solutionDropdownRef"
                                 v-bind:cmpyCd="cmpyCd"
              ></dropdown-solution>
            </li>
            <li class="w30">
              <kendo-dropdownlist
                ref="wmGbnRef"
                id="wmGbn"
                :data-source="wmGbnDataSource"
                :data-text-field="'cvtWmGbn'"
                :data-value-field="'wmGbn'"
                :option-label="'웹/모바일구분 선택'"
                :no-data-template="'웹/모바일구분을 선택해주세요.'"
                :style="'width: 100%;'"
                @change="onClickSearch"
              >
              </kendo-dropdownlist>
            </li>
            <li class="w20">
              <button class="mid_btn orange" @click="onClickSearch"><span class="k-icon k-i-zoom"></span> 검색 </button>
            </li>
          </ul>
        </div>
        <!-- Kendo 영역 -->
        <kendo-grid ref="solutionAuthListWindowGridRef"
                    id="solutionAuthListWindowGrid"
                    :height="301"
                    :navigatable="true"
                    :filterable="false"
                    :sortable="true"
                    :scrollable="true"
                    :pageable-always-visible="false"
                    :reorderable="true"
                    :column-menu="false"
                    :resizable="true"
                    :selectable="'multiple row'"
                    :columns="gridColumns"
                    :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }"
        >
        </kendo-grid>
        <!-- Kendo 영역 끝 -->
        <div class="button_wrap_area">
          <ul>
            <li>
              <button class="large_btn orange" @click="onClickSet">확인 </button>
            </li>
            <li>
              <button class="large_btn" @click="onClickClose">취소</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </kendo-window>
</template>

<script>
  import ApiUtil from '@/api/api.util'
  import ApiConfig from '@/api/api.config'
  import EtnersCommonUtil from '@/common/etners.common.util'
  import EtnersParseUtil from '@/common/etners.parse.util'
  import DropdownSolution from '@/components/admin/DropdownSolution'

  export default {
    name: "UserSolutionListWindow",
    props: [ 'cmpyCd', 'exceptSolutionAuthList' ],
    components: {
      DropdownSolution
    },
    created: function() {

    },
    mounted: function() {

      const vm = this

      // 솔루션 dropdownlist option-label 셋팅
      vm.$refs.solutionDropdownRef.$refs.solCdRef.kendoWidget().setOptions({ optionLabel: '솔루션 선택' })

      // 솔루션 dropdownlist change event
      vm.EventBus.$on('onChangeDropdownSolutionComponent', function (data) {
        vm.solCd = data.solCd

        // 솔루션구분 dropdownlist dataSource 및 선택 초기화
        vm.wmGbnDataSource = []
        vm.$refs.wmGbnRef.kendoWidget().select(0)

        // 검색 처리
        vm.onClickSearch()


        // 솔루션구분 dropdownlist dataSource 구성
        let param = {
          loginUserToken: sessionStorage.lutk,
          solCd: vm.solCd
        }
        ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/solution/solutionWmGbnList.json`, param)
        .then(response => {

          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터가 정상적으로 조회되지 않았습니다.')
          }
          if (response.data.resultStatus.messageCode !== '2000') {
            kendo.alert(response.data.resultStatus.messageText)
          }

          let changeResultData = response.data.resultData

          // 공통코드 처리
          let commonCodeMap = EtnersCommonUtil.getAllCommonCodeMapUsingVuex()
          if(commonCodeMap !== undefined) {
            for (let i=0; i<changeResultData.length; i++) {
              let row = changeResultData[i]
              row.cvtWmGbn = EtnersParseUtil.commonCodeToText(commonCodeMap, row.wmGbn)
            }
          }

          vm.wmGbnDataSource = changeResultData

        })
      })
    },
    methods: {
      getAuthList: function(param) {

        return new Promise(resolve => {

          ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/user/notAddedUserSolutionAuthList.json`, param)
          .then(response => {

            if (response.data === undefined || response.data.resultStatus === undefined) {
              kendo.alert('데이터가 정상적으로 조회되지 않았습니다.')
              return false
            }
            if (response.data.resultStatus.messageCode !== '2000') {
              kendo.alert(response.data.resultStatus.messageText)
              return false
            }

            let authListResponse = response.data.resultData

            resolve(authListResponse)
          })
          .catch(error => {
            console.log(error)
          })
        })
      },

      /**
       * 버튼 관련 이벤트 methods
       */
      onClickSearch: function(e) {
        /* 검색 버튼 클릭 이벤트 */
        const vm = this

        // 그리드 dataSource 초기화
        vm.$refs.solutionAuthListWindowGridRef.kendoWidget().setDataSource([])

        if(vm.solCd === undefined || vm.solCd === null || vm.solCd === '') {
          // kendo.alert('솔루션을 선택해주세요.')
          return false
        }

        let wmGbn = vm.$refs.wmGbnRef.kendoWidget().value()
        wmGbn = EtnersParseUtil.extractCodeFromCodeGrupFormat(wmGbn)

        let param = {
          loginUserToken: sessionStorage.lutk,
          targetCmpyCd: vm.$props.cmpyCd,
          targetSolCd: vm.solCd,
          wmGbn: wmGbn
        }
        vm.getAuthList(param).then(function(response) {

          // 부모화면에서 전달받은 제외할 권한코드 response에서 제거
          if(vm.$props.exceptSolutionAuthList !== undefined && vm.$props.exceptSolutionAuthList !== null) {

            vm.$props.exceptSolutionAuthList.forEach(function(elementExcept, indexExcept) {
              response.forEach(function(elementResponse, indexResponse) {

                let exceptWmGbn = EtnersParseUtil.extractCodeFromCodeGrupFormat(elementExcept.wmGbn)
                let responseWmGbn = EtnersParseUtil.extractCodeFromCodeGrupFormat(elementResponse.wmGbn)

                if(elementExcept.solCd === elementResponse.solCd && exceptWmGbn === responseWmGbn && elementExcept.authCd === elementResponse.authCd) {
                  response.splice(indexResponse, 1)
                }
              })
            })
          }

          // 공통코드 처리
          let commonCodeMap = EtnersCommonUtil.getAllCommonCodeMapUsingVuex()
          if(commonCodeMap !== undefined) {
            for(let i=0; i<response.length; i++) {
              let row = response[i]
              row.wmGbn = EtnersParseUtil.convertCodeGrupFormat('102', row.wmGbn)
              row.cvtWmGbn = EtnersParseUtil.commonCodeToText(commonCodeMap, row.wmGbn)
            }
          }


          // 그리드 dataSource
          vm.$refs.solutionAuthListWindowGridRef.kendoWidget().setDataSource(response)
        })

      },
      onClickSet: function(e) {
        /* 확인 버튼 클릭 이벤트 */

        const vm = this

        let selectedRows = vm.$refs.solutionAuthListWindowGridRef.kendoWidget().select()

        if(selectedRows.length === 0) {
          kendo.alert("선택된 권한이 없습니다.")
          return false
        }

        vm.selectedRowDataList = []
        for(let i=0; i<selectedRows.length; i++) {
          let rowData = vm.$refs.solutionAuthListWindowGridRef.kendoWidget().dataItem(selectedRows[i])
          rowData.useYn = 'Y'
          vm.selectedRowDataList.push(rowData)
        }

        // 부모화면에 선택한 row data list 전달
        vm.$parent.callbackFromSolutionAuthListWindow(vm.selectedRowDataList)
        vm.onClickClose(e);
      },
      onClickClose: function(e) {
        /* 취소 버튼 클릭 이벤트 */
        // window 닫기
        this.$refs.kendoWindowRef.kendoWidget().close()
      },
      onCloseKendoWindow: function(e) {
        /* window on close 이벤트 */

        // 솔루션 dropdownlist 선택 초기화
        this.$refs.solutionDropdownRef.$refs.solCdRef.kendoWidget().select(0)
        // 그리드 dataSource 초기화
        this.$refs.solutionAuthListWindowGridRef.kendoWidget().setDataSource([])
      },
    },
    data: function() {
      const kendoGridHeaderAttributes = {
        style: 'font-weight: bold;',
      }

      return {
        solCd                   : '',
        selectedRowDataList     : [],
        gridColumns: [
          { selectable: 'true', width: '10%' },
          { field: 'solCd', title: '솔루션코드', width: '10%', headerAttributes: kendoGridHeaderAttributes },
          { field: 'solNm', title: '솔루션명', width: '30%', headerAttributes: kendoGridHeaderAttributes },
          { field: 'cvtWmGbn', title: '웹/모바일구분', width: '30%', headerAttributes: kendoGridHeaderAttributes },
          { field: 'authCd', title: '권한코드', width: '10%', headerAttributes: kendoGridHeaderAttributes },
          { field: 'authNm', title: '권한명', width: '20%', headerAttributes: kendoGridHeaderAttributes },
        ],
        wmGbnDataSource: []
      }
    }
  }
</script>

<style scoped>

</style>
